// extracted by mini-css-extract-plugin
export default {"header-left":"HeaderLeft_header-left__Cl5LU"};